import React from 'react';
import { Loading } from 'splash/components';

const GenericRoute = () => <Loading type="loading" />;

export default GenericRoute;
